import { render, staticRenderFns } from "./BuyersTable.vue?vue&type=template&id=1bfd3b95&scoped=true&"
import script from "./BuyersTable.vue?vue&type=script&lang=js&"
export * from "./BuyersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd3b95",
  null
  
)

export default component.exports